import { render, staticRenderFns } from "./Canadian.vue?vue&type=template&id=2c7e67d2&"
import script from "./Canadian.vue?vue&type=script&lang=js&"
export * from "./Canadian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports